var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import { msgType } from '../../enum/msg-center';
export default Vue.extend({
    name: 'msgWindow',
    computed: __assign({}, mapState('common', {
        isOpenMsgListModel: 'isOpenMsgListModel',
        msgList: 'windowMsgList',
    })),
    data: function () {
        return {
            noViewList: [],
        };
    },
    created: function () {
        this.$store.dispatch('common/GET_MSGLIST', {
            pageNo: 1,
            pageSize: 1000,
            viewStatus: 'NO_VIEW',
            position: 'window',
        });
    },
    methods: {
        letterSwitch: function (val) {
            var len = val.length;
            if (len > 50) {
                return val.slice(0, 47) + "...";
            }
            return val;
        },
        tabReadStatus: function (index, flag) {
            this.noViewList[index]['isShowRead'] = flag;
        },
        tagRead: function (_a, type) {
            var msgCode = _a.msgCode, msgType = _a.msgType;
            this.$store.dispatch('common/TAG_READSTATUS', {
                msgList: [
                    {
                        msgCode: msgCode,
                        msgType: msgType,
                    },
                ],
                type: type,
                callback: this.updateStatus,
            });
        },
        updateStatus: function () {
            this.$store.dispatch('common/UPDATESTATUS');
        },
        toLandingPage: function (data) {
            this.tagRead(data, 'stop');
            this.$store.dispatch('common/TOLANDDINGPAGE', {
                data: data,
                this_: this,
            });
        },
        closeWindow: function () {
            this.$store.commit('common/update', {
                isOpenMsgListModel: false,
            });
        },
        toMsgList: function () {
            this.$omega.trackEvent('dafs_unview_list_look_pv');
            this.closeWindow();
            this.$router.push({ name: 'messageList' });
        },
        msgTypeTxt: function (val) {
            return msgType[val];
        },
    },
    watch: {
        msgList: {
            handler: function (val) {
                this.noViewList = val;
            },
            deep: true,
        },
    },
});
